__turbopack_context__.v({
  "container": "-YjeZa_container",
  "content": "-YjeZa_content",
  "link": "-YjeZa_link",
  "paragraph": "-YjeZa_paragraph",
  "shimmer": "-YjeZa_shimmer",
  "subtitle": "-YjeZa_subtitle",
  "text-bar-sweep": "-YjeZa_text-bar-sweep",
  "title": "-YjeZa_title",
});
